import MatchingDimensionCard from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/MatchingDimensionCard'

export default function DimensionMatchMessage({
  dimension,
  match,
  text_modules,
  insights_labels,
  language,
  displayTextModules,
  displayInsights,
  onlyDisplayChancesAndRisks
}) {
  console.log('dimension', dimension)
  return (
    <MatchingDimensionCard
      {...{
        dimension,
        match,
        text_modules,
        insights_labels,
        language,
        displayTextModules,
        displayInsights,
        onlyDisplayChancesAndRisks
      }}
    />
  )
}
